import { Link, Stack } from "@mui/material";
import Iconify from "../../../minimals/components/iconify";
import { ContactInfo } from "../types";

function formatPhoneNumber(phone: string): string {
  const digits = phone.replace(/\D/g, "");

  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (digits.length === 11 && digits[0] === "1") {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  return phone;
}

export default function ({ contactInfo }: { contactInfo: ContactInfo }) {
  return (
    <>
      {contactInfo.email && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Iconify icon="eva:email-outline" width={18} />
          <Link href={`mailto:${contactInfo.email}`}>{contactInfo.email}</Link>
        </Stack>
      )}
      {contactInfo.phone && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Iconify icon="eva:phone-outline" width={18} />
          <Link href={`tel:${contactInfo.phone}`}>{formatPhoneNumber(contactInfo.phone)}</Link>
        </Stack>
      )}
      {(contactInfo.city || contactInfo.state) && (
        <Stack direction="row" spacing={1} alignItems="center">
          <Iconify icon="eva:pin-outline" width={18} />
          <span>{[contactInfo.city, contactInfo.state].filter(Boolean).join(", ")}</span>
        </Stack>
      )}
    </>
  );
}
